<template>
  <layout-apply-cancel
    :standalone="overlayTrackStandAlone"
    @cancel="cancel"
    @apply="applyClick"
  />
</template>

<script>
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import PageMixin from 'AssetEditor/pages/PageMixin.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  computed: {
    ...mapState('assetEditor', [
      'overlayTrackStandAlone',
      'tempTracks',
      'workModel',
    ]),
  },

  mixins: [PageMixin],

  mounted: function () {
    bus.$on('apply', this.apply);
  },

  beforeDestroy: function () {
    bus.$off('apply', this.apply);
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage']),
    ...mapMutations('assetEditor', ['applyOverlayTracks']),

    cancel() {
      if (this.overlayTrackStandAlone) {
        bus.$emit('cancel');
      } else {
        this.changeCurrentPage('preview');
      }
    },

    isDirty() {
      const cleanTrack = (track) => ({
        sceneLayout: _.omit(track.sceneLayout, [
          'canSwitchMainAndOverlay',
          'borderPresets',
          'animationPresets',
          'layoutPosition',
          'layoutWindow',
        ]),
        agd: _.pick(track.agd, ['scale', 'customOverlays']),
        sceneAgd: _.pick(track.sceneAgd, ['offset', 'scale']),
      });
      const roundIfInfinitesimal = (n) => {
        const rounded = Math.round(n);
        const diff = Math.abs(n - rounded);
        return diff < 1e-10 ? rounded : n;
      };
      const roundOffset = (offset) => {
        if (!offset) {
          return offset;
        }
        const o = {};
        o.left = roundIfInfinitesimal(offset.left);
        o.top = roundIfInfinitesimal(offset.top);
        return o;
      };
      let ar1 = this.tempTracks.map((t) => cleanTrack(t));
      let ar2 = this.workModel.overlayTracks.map((t) => cleanTrack(t));
      if (!_.isEqual(ar1, ar2)) {
        return true;
      }
      ar1 = this.tempTracks.map((t) => roundOffset(t.agd.offset));
      ar2 = this.workModel.overlayTracks.map((t) => roundOffset(t.agd.offset));
      return !_.isEqual(ar1, ar2);
    },

    backToPreview: function () {
      this.askSaveChanges(this.isDirty());
    },

    applyClick() {
      bus.$emit('apply-click');
    },
    /**
     * Emit apply event
     * caught by assetEditorVue's active child component
     */

    apply: function () {
      this.applyOverlayTracks();
      if (this.overlayTrackStandAlone) {
        bus.$emit('done');
        // destroyed
      } else {
        this.changeCurrentPage('preview');
      }
    },
  },
};
</script>
